import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VariablesService } from 'src/app/shared/services';

@Component({
  selector: 'app-multi-patient-note',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './multi-patient-note.component.html',
  styleUrls: ['./multi-patient-note.component.scss']
})
export class MultiPatientNoteComponent {

  public readonly vars = inject(VariablesService);

  @Input() theme;

  showDesc = false;

  onShowClick(e) {
    this.showDesc = e;
  }

}
